var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOnboardingIcStart(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "onboardingIcStart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M218.160483,550.423216 C218.414005,550.176538 218.503499,549.814503 218.394146,549.47796 C218.284536,549.141417 217.999033,548.901176 217.648281,548.850193 L214.529676,548.397778 C214.396854,548.378466 214.282085,548.295296 214.222767,548.175047 L212.828525,545.353956 C212.671975,545.036982 212.354235,544.84 212.000129,544.84 C211.646281,544.84 211.328541,545.036982 211.171991,545.353956 L209.777491,548.175304 C209.718173,548.295553 209.603146,548.378723 209.470324,548.398035 L206.351719,548.85045 C206.001224,548.901176 205.715464,549.141675 205.605854,549.478218 C205.496501,549.814761 205.585995,550.176796 205.839517,550.423474 L208.095941,552.619372 C208.19214,552.7131 208.236242,552.848026 208.213546,552.979862 L207.681227,556.08059 C207.63403,556.353533 207.705728,556.619008 207.882652,556.828349 C208.15758,557.154593 208.637544,557.253985 209.021309,557.052626 L211.81031,555.588522 C211.926884,555.527496 212.073632,555.528011 212.189948,555.588522 L214.979207,557.052626 C215.114865,557.123951 215.259551,557.16 215.408879,557.16 C215.681486,557.16 215.939908,557.038978 216.117606,556.828349 C216.294787,556.619008 216.366228,556.353018 216.319031,556.08059 L215.786454,552.979862 C215.763758,552.847768 215.80786,552.7131 215.904059,552.619372 L218.160483,550.423216 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Discover-Copy-3",
    transform: "translate(-205.000000, -544.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "onboardingIcStart",
    fill: "#10C2E1",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnboardingIcStart);
export default __webpack_public_path__ + "static/media/onboardingIcStart.f90463b049e9af0def6d1ef2f09e78d4.svg";
export { ForwardRef as ReactComponent };